import UCL from "./user-client-libs";

async function authenticatedFetch(url, options = {}) {
    const uclInstance = new UCL();
    const { userBearerAccessToken, userIdToken } = await uclInstance.getUserTokens();

  const newHeaders = {
    ...options.headers,
    Authorization: userBearerAccessToken,
    'X-Token': userIdToken
  };

  const newOptions = {
    ...options,
    headers: newHeaders,
  };

  const response = await fetch(url, newOptions);

  return response;
}

export default authenticatedFetch;
